<template>
    <div class="display-block">
        <h3>Vendor</h3>
        <v-card flat>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 sm6>
                        <row-item label="Business Name  " :value="vendor.businessName"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Description  " :value="vendor.description"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Store" :value="generateUrl(vendor.slug)"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Mobile Number  " :value="vendor.mobileNo"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Whatsapp Number  " :value="vendor.whatsappNo"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Email  " :value="vendor.email"></row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Status">
                            <vendor-account-status :status="vendor.accountStatus"></vendor-account-status>
                        </row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Allowed Modules">
                            <modules-list :allowedModules="vendor?.licensingDetails?.allowedModules"></modules-list>
                        </row-item>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <row-item label="Created On:">
                            {{ vendor.createdAt | dateFormat }}
                        </row-item>
                    </v-flex>
                    <v-flex v-if="vendor.address" sm12>
                        <row-item label="Address  " :value="vendor.address"></row-item>
                    </v-flex>
                    <v-flex v-if="vendor.area" sm4>
                        <row-item label="Area  " :value="vendor.area"></row-item>
                    </v-flex>
                    <v-flex v-if="vendor.city" sm4>
                        <row-item label="City  " :value="vendor.city"></row-item>
                    </v-flex>
                </v-layout>
                <h3>Staffs</h3>
                <v-list>
                    <v-list-item v-for="item in users" :key="item._id">
                        <staff-card :id="item._id" :name="`${item.firstName} ${item.lastName}`" :mobileNo="item.mobileNo"
          :email="item.email" :roles="item.roles"></staff-card>
                    </v-list-item>
                </v-list>
            </v-card-text>
        </v-card>
        <v-flex text-right>
            <v-btn @click="$router.go(-1)" class="ma-2" :style="theme">Back</v-btn>
        </v-flex>
    </div>
</template>

<script>
import appConstants from '@/utils/appConstants'
import RowItem from '@/components/RowItem'
import ModulesList from '../../../components/ModulesList.vue'
import VendorAccountStatus from '../../../components/VendorAccountStatus.vue'
import StaffCard from '@/components/UserResponsiveCard';
export default {
    components: {
        RowItem,
        ModulesList,
        VendorAccountStatus,
        StaffCard
    },
    data() {
        return {
            id: 0,
            items: [],
            vendor: {
                businessName: "",
                mobileNo: "",
                email: "",
                address: "",
                city: "",
                area: ""
            },
            users: []
        }
    },
    mounted() {
        this.initComponent();
    },
    methods: {
        async initComponent() {
            this.id = this.$route.params.id
            this.vendor = await this.getItem(appConstants.VENDORS_API + "/" + this.id)
            this.users = (await this.getItem(appConstants.STAFFS_API + "?userType=STAFF&conditions=userType=STAFF,vendorId=" + this.id)).data
        }
    }
}
</script>
